import { Dispatch, SetStateAction, useState } from 'react';
import useCollapseDrawer from '~/hooks/useCollapseDrawer';
import useResponsive from '~/hooks/useResponsive';

type DashboardLayoutResult = {
  collapseClick: boolean;
  isCollapse?: boolean;
  isDesktop?: boolean;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const useDashboardLayout = (): DashboardLayoutResult => {
  const { collapseClick, isCollapse } = useCollapseDrawer();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  return {
    collapseClick,
    isCollapse,
    isDesktop,
    open,
    setOpen,
  };
};

export default useDashboardLayout;
